import { SearchBaseModel } from '../commonModels';

export class DepositeSearchModel extends SearchBaseModel {

  constructor() {
    super();
    this.GarageId = null;
    this.CustomerId = null;
    this.DepositeInventoryStatusId = null;
    this.TryeStateValueId = null;
    this.Garage = null;
    this.Customer = null;
    this.RegistrationNumber = null;
    this.Tyre = null;
    this.GarageDepositeNumber = null;
    this.DepositeAge = null;
    this.Note = null;
    this.IsInventoryChange = null;
    this.IsRim = null;
    this.IsLowThread = null;
    this.IsCarActive = null;
    this.SeasonId = null;
    this.IsAnySpecificationActive = null;
    this.Garage_IsTyreSendingBlocked = null;
    this.OrderTypeId = null;
    this.IsShipment = null;
    this.CarId = null;
    this.GlobalSearch = null;
    this.DepositeId = null;
    this.MarkAll = null;
  }



  public GarageId: number;
  public CustomerId: number;
  public DepositeInventoryStatusId: number;
  public TryeStateValueId: number;
  public Garage: string;
  public Customer: string;
  public RegistrationNumber: string;
  public Tyre: string;
  public GarageDepositeNumber: string;
  public DepositeAge: number;
  public Note: string;
  public IsInventoryChange: boolean;
  public IsRim: boolean;
  public IsLowThread: boolean;
  public IsCarActive: boolean;
  public SeasonId: number;
  public IsAnySpecificationActive: boolean;
  public Garage_IsTyreSendingBlocked: boolean;
  public OrderTypeId: number;
  public IsShipment: boolean;
  public CarId: number;
  public Version: number;
  public GlobalSearch: boolean;
  public DepositeId: number;
  public MarkAll: boolean;
  public DepositeIds: number[];
  public CarRegistrationNumbers: string[];
  public IsTyreUnspecified: boolean;
}
